export class UserRightAll {
  public id: number;
  public active: boolean;
  public baseSur: number;
  public controleurScanRepertoire: string;
  public login?: string;
  public guid?: string;
  public options?: {
    fullView: boolean; // Vue complète des documents
    encodageToutService: boolean; // Encodage dans tous les services
  };
  public globalAccessRight: {
    // description: Droits d'accès général
    accesAdminSysteme: boolean; // Administrateur système
    accesBackupDatabase: boolean;
    accesDossiersClassement: boolean; // Gestion des dossiers de classement et propriétés étendues
    accesDossiersClassementPartiel: boolean; //  Gestion des dossiers de classement et propriétés étendues - Uniquement services dont membre
    accesModuleDiv: boolean; // Accès au module Div
    accesModuleRn: boolean; // Accès au module Rn
    accesModuleBce: boolean; // Accès au module BCE
    accesContactUpdateRnTva: boolean; // Déverrouiller les zones nom / prénom / RN / TVA d'un contact
    accesDoublonsContact: boolean; // Gestion des doublons de contact
  };
  public managementAccessRight: {
    // description: Droits de gestion globale
    accesCourrier: boolean; // Accès gestion globale des courriers
    accesContact: boolean; // Accès gestion globale des contacts
    accesAdmin: boolean; //  Accès gestion globale des utilisateurs, services et profils
    accesModeleDocument: boolean; // Accès gestion globale des modèles de document
    accesClassement: boolean; // Accès gestion globale des classements
  };

  public mailAccessRight: {
    // description: Droits d'accès aux courriers
    accesModuleCourrier: boolean; // Autoriser l'accès au module des courriers
    creationCourrierEntrant: boolean;
    creationCourrierSortant: boolean;
    accesCourrierHistorique: boolean;
    accesCourrierDroit: boolean;
    controleurQualiteScan: boolean;
    restrictiScanToParentService: boolean;
    accesDocumentACompleter: boolean;
    accesExpedition: boolean;
    limiterExpeditionService: boolean;
    limiterExpeditionDocument: boolean;
    accesCourrierOutil: boolean;
    accesEncodageRetourCourrier?: boolean; // Accès à l'encodage de retour de courriers
    accesArchivageMasseCourrier?: boolean; // Accès aux actions de la distribution de masse
  };
}
